<template>
  <div class="atividades-monitoramentotabela ml-4 mr-4" >
      <b-form>          
          <b-row>
              <b-col>
                  <b-form-group label="Tabela:" label-for="tabela">
                      <b-form-input id="tabela" type="text"
                        v-model="tabela" required                        
                        placeholder="Informe o numero da tabela." />
                  </b-form-group>
              </b-col>           
             
              <b-col>
                   <div>                            
                        <label  for="datepicker-placeholder">Data escala de serviço</label>
                        <b-form-datepicker id="datepicker-placeholder"  v-model="data_servico" placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>              
          </b-row>

          <b-row>
                <b-col xs="12">
                    <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadMonitoramentoTabela()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                    </b-button>                      
                </b-col>
          </b-row>
    </b-form>
    <hr>
    <b-table small hover striped :items="monitoramentotabela" :fields="fields">                           
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import moment from 'moment'


export default {    
    name: 'TraAtividadesMonitoramentoTabela',

    data: function() {
        return {
            mode: 'save',
            carregando: false,            
            monitoramentotabela:[],// [] lista  

            
           
            
            data_servico: '',
            
            fields: [
                //{ key: 'data_servico', label: 'Data Serviço', sortable: true, formatter: (value, key, monitoramentotabela) => {return moment(monitoramentotabela.data_servico).format('DD/MM/YYYY');} },
                { key: 'carro', label: 'Carro', sortable: true },
                { key: 'tabela', label: 'Tabela', sortable: true },
                { key: 'mot_pro', label: 'Mot pro', sortable: true },          
                { key: 'mot_real', label: 'Mot real', sortable: true },          
                { key: 'cob_prog', label: 'Cob pro', sortable: true },          
                { key: 'cob_real', label: 'Cob real', sortable: true },                          
                { key: 'linha', label: 'Linha', sortable: true },                
                { key: 'sentido', label: 'Sentido', sortable: true },         
                { key: 'fiscal', label: 'fiscal', sortable: true },
                { key: 'status_viagem', label: 'status_viagem', sortable: true },
                { key: 'atividade', label: 'Atividade', sortable: true },

                { key: 'dh_hora_chegada', label: 'Chegada Prog', sortable: true, formatter: (value, key, monitoramentotabela) => {
                    return moment(monitoramentotabela.dh_hora_chegada).format('DD/MM/YYYY HH:MM').replace('Invalid date','-');} },
                { key: 'hora_chegada_real', label: 'Chegada real', sortable: true },

                { key: 'dh_hora_saida', label: 'Saida Prog', sortable: true, formatter: (value, key, monitoramentotabela) => {
                    return moment(monitoramentotabela.dh_hora_saida).format('DD/MM/YYYY HH:MM').replace('Invalid date','-');} },
                    

                { key: 'dh_hora_saida', label: 'Saida pro', sortable: true },
                { key: 'hora_saida_real', label: 'Saida real', sortable: true },


                { key: 'dt_postgres', label: 'JB_POSTGRES', sortable: true, formatter: (value, key, monitoramentotabela) => {
                    return moment(monitoramentotabela.dt_postgres).format('DD/MM/YYYY HH:MM').replace('Invalid date','-');} },

                
                { key: 'usuario_windows', label: 'usuario_windows', sortable: true },

                { key: 'dt_sincronizacao', label: 'Dt sincronização', sortable: true, formatter: (value, key, monitoramentotabela) => {
                    return moment(monitoramentotabela.dt_sincronizacao).format('DD/MM/YYYY HH:MM').replace('Invalid date','-');} },


                
                { key: 'origem', label: 'origem', sortable: true },
                { key: 'alterado_por', label: 'alterado_por', sortable: true },

                { key: 'data_alteracao', label: 'Dt alteração', sortable: true, formatter: (value, key, monitoramentotabela) => {
                    return moment(monitoramentotabela.data_alteracao).format('DD/MM/YYYY HH:MM:SS').replace('Invalid date','-');} },



                    
            ]
        }        
    },


    methods: {

        loadMonitoramentoTabela() {
         
          const url = `${baseApiUrl}/trafego/monitoramentotabela/${this.tabela}/${this.data_servico}`          
          axios.get(url).then(res => {
            this.carregando = false;
            this.monitoramentotabela = res.data.map(monitoramentotabela => {
                            return {
                                data_servico: monitoramentotabela.data_servico, 
                                carro: monitoramentotabela.carro, 
                                mot_pro: monitoramentotabela.mot_pro,
                                mot_real: monitoramentotabela.mot_real, 
                                cob_prog: monitoramentotabela.cob_prog,
                                cob_real: monitoramentotabela.cob_real,                                
                                tabela: monitoramentotabela.tabela,
                                linha: monitoramentotabela.linha,
                                sentido: monitoramentotabela.sentido, 
                                fiscal: monitoramentotabela.fiscal, 
                                status_viagem: monitoramentotabela.status_viagem, 
                                atividade: monitoramentotabela.atividade, 
                                dh_hora_chegada: monitoramentotabela.dh_hora_chegada,
                                hora_chegada_real: monitoramentotabela.hora_chegada_real,
                                dh_hora_saida: monitoramentotabela.dh_hora_saida,
                                hora_saida_real: monitoramentotabela.hora_saida_real,                                
                                dt_postgres: monitoramentotabela.dt_postgres,
                                usuario_windows: monitoramentotabela.usuario_windows,
                                dt_sincronizacao: monitoramentotabela.dt_sincronizacao,
                                origem: monitoramentotabela.origem,
                                alterado_por: monitoramentotabela.alterado_por,
                                data_alteracao: monitoramentotabela.data_alteracao

               }              
            })
          })
        }, 
    },

    mounted() {        
        this.loadmonitoramentotabela()
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.7em;
}
</style>
